import echarts from "echarts/dist/echarts";
import { SelectedVersions } from "../chats/state/chat.model";
import { Palette } from "../shared/color-themes/color-themes";
import { SpecificChartType } from "./charts/chart.value-objects";

export class ChartCategoricalFrequency {
  schema: string;
  element: string;
  frequency: number;
  sentiment: number;
}

export class SimpleFrequencyData {
  name: string;
  value: number;
  sentiment: number;
  secondaryField: number;
  Frequency?: string;
  indexSerie?: number;
  indexData?: number;
}

export class TimeSeriesRecord extends SimpleFrequencyData {
  average: number;
  category: any[];
  dateTime: number;
  seriesName: string;
}

export class TimeSeriesFrequencyData {
  name: string;
  data: TimeSeriesRecord[];
}

export class GroupFrequencyData {
  frequency_count: number;
  name: string;
  sentiment: number;
}

export class GroupedBarResponse {
  group: string;
  seriesData: GroupFrequencyData[];
}

export class ScatterResponse {
  key_value: string;
  x_axis_value: string;
  y_axis_value: string;
}

export class GroupedBarData {
  group: string;
  seriesData: {
    [key: string]: number;
  };
}

export class TimeSeries {
  // 'value' is placeholder for structured field
  dateTime: string;
  value: any;
  effort: number;
  sentiment: number;
}

export class CategoricalScatter {
  name: string;
  data: {
    dateTime: string;
    value: number;
  };
}

export class TimeSeriesData {
  name: string;
  data: TimeSeries[];
}

export class TimeSeriesCombo {
  startTime: string;
  endTime: string;
  categoricalScatter: CategoricalScatter | any;
  sentimentTimeSeries: TimeSeries;
  effortTimeSeries: TimeSeries;
}

export enum Endpoints {
  timeSeriesURL = "assets/temp-mock-data/time_series.json",
  timeSeriesComboURL = "assets/temp-mock-data/time_series_combo.json",
  timeSeriesComboURL2 = "assets/temp-mock-data/time_series_combo_2.json",
}

export interface ChartsField {
  path: string;
  name: string;
  label: string;
  type: string;
  value: string;
}

export interface ChartsFieldsGroup {
  group_type: string;
  fields: ChartsField[];
  disabled?: boolean;
}

export interface CommonFrequencyParams {
  index_id: string;
  data_source_type?: string;
  session?: string;
  selected_field?: string;
  field_type?: string;
  current_partition?: number;
  partitions?: number;
}
export interface ChatFrequencyParams extends CommonFrequencyParams {
  field_path: string;
  field_name: string;
  field_path_sub?: string;
  field_name_sub?: string;
  date_field?: string;
  size?: number;
}

export interface ChatFrequencyParamsExt extends ChatFrequencyParams {
  time_interval: string;
  date_field: string;
}

export interface ScatterParams extends CommonFrequencyParams {
  x_axis_path: string;
  x_axis_field: string;
  y_axis_path: string;
  y_axis_field: string;
  field_name: string;
  field_path: string;
}

export class ChartOptions {
  maxScale?: boolean;
  markLines?: boolean;
  palette?: Palette;
}
export interface ChatFrequencyGroupParams extends CommonFrequencyParams {
  field_path: string;
  field_name: string;
  group_path: string;
  group_name: string;
  group_type?: string;
  group_value?: string;
  field_size?: number;
  group_size?: number;
  time_value?: string;
}

export interface GetTranscriptParams
  extends ChatFrequencyParamsExt, ChatFrequencyGroupParams {
  name: string;
  data_index: number;
  value: any;
}

export interface TranscriptParams {
  echartsInstance: any;
  chatFrequencyParams: any;
  type: any;
}

export interface nplChartParams {
  pos: number;
  t_entities: number;
  t_lemma: number;
  t_ngrams: number;
  value: number;
}

export interface predictorsChartParams {
  topic: number;
  intent: number;
  emotion: number;
  segment: number;
  emitter_role: number;
  fluff: number;
  effort: number;
  sentiment: number;
}

export interface insightsChartParams {
  NLP: nplChartParams;
  Predictors: predictorsChartParams;
  sentences_count: number;
}

export interface labelsCatalog {
  effort: string;
  emitter_role: string;
  emotion: string;
  fluff: string;
  intent: string;
  phrase: string;
  pos: string;
  segment: string;
  sentiment: string;
  t_entities: string;
  t_lemma: string;
  t_ngrams: string;
  topic: string;
  value: string;
}

export const DateTimeFormat = {
  msg_date: "MM/DD/YYYY",
  msg_date_time: "MM/DD/YYYY h:mm:ss A",
  msg_time: "h:mm:ss A",
};

export const UnixDateFormat = {
  msg_date: (val) => val,
  msg_date_time: "MM/DD/YYYY h:mm:ss A",
  msg_time: "h:mm:ss A",
};

export interface RenderOptions {
  scale?: boolean;
  lines?: boolean;
  percentage?: boolean;
}

export interface TranscriptArgs {
  chartParams: any;
  echartsInstance: echarts.ECharts;
  chatFrequencyParams:
    | ChatFrequencyParams
    | ChatFrequencyGroupParams
    | ChatFrequencyParamsExt;
  models: SelectedVersions[];
  type: SpecificChartType;
  theme?: string[];
  current_partition?: number;
  partitions?: number;
}

export interface CatData {
  label: string;
  id: string;
}

export interface HeatMapChartData {
  yAxis: {
    title: string;
    data: CatData[];
  };
  xAxis: {
    title: string;
    data: CatData[];
  };
  data: number[][];
  title: string;
}
